import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { EQUIPMENT_SEARCH_LIMIT } from '@brokerportal/common/utils/equipment-search';
import {
    HeatPumpSearchResponse,
    HESLP_HEAT_PUMP_SEARCH_PRODUCT
} from '@brokerportal/common/models/application/heat-pump-reference-data.model';

/**
 * ESC-approved heat pump water heater search (ESC-117/ESC-118). Mirrors `AirconReferenceDataService`, but the
 * endpoint is HESLP-scoped, so `product=HESLP` is always sent: there is no unfiltered variant to fall back to.
 */
@Injectable({ providedIn: 'root' })
export class HeatPumpReferenceDataService {
    private readonly baseUrl: string;

    constructor(private httpClient: HttpClient) {
        this.baseUrl = environment.useDirectQuoteService ? environment.quoteServiceHost : environment.api.baseUrl;
    }

    searchHeatPumps(query: string, limit = EQUIPMENT_SEARCH_LIMIT): Observable<HeatPumpSearchResponse> {
        const params = new HttpParams()
            .set('search', query)
            .set('limit', String(limit))
            .set('product', HESLP_HEAT_PUMP_SEARCH_PRODUCT);
        return this.httpClient.get<HeatPumpSearchResponse>(
            `${this.baseUrl}/${environment.referenceDataRoute}/heat-pumps`,
            { params }
        );
    }
}
